import { Component, Vue } from 'vue-property-decorator';
import authenticator from '@/store/authentication';

@Component
export default class AuthorizationCallback extends Vue {

  private async created() {
    await authenticator.completeSignInAsync()
      .then((result) => {
        if (result.success) {
          this.$router.push({ name: 'home', params: {locale: 'en'} });
        } else {
          this.$router.push({ name: 'unauthorized' });
        }
      });
  }
}